import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component'
import { UserPanelComponent } from './user-panel/user-panel.component';
import { CalculatorComponent } from './calculator/calculator.component';
import { ClipComponent } from './clip/clip.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { OnlyChromeComponent } from './only-chrome/only-chrome.component';
import { QuizComponent } from './quiz/quiz.component';
import { YtVideosComponent } from './yt-videos/yt-videos.component';
export const routes: Routes = [
  { path: '', redirectTo: 'kalkulator', pathMatch: 'full' },
  { path: 'kalkulator', component: CalculatorComponent },
  { path: 'korisnik', component: UserPanelComponent },
  { path: 'klip', component: ClipComponent },
  { path: 'uslovi-koriscenja', component: TermsOfServiceComponent },
  { path: 'test', component: QuizComponent },
  { path: 'only-chrome', component: OnlyChromeComponent },
  { path: 'klipovi-youtube', component: YtVideosComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
